import { jsxs as b, jsx as t } from "react/jsx-runtime";
import { useState as _ } from "react";
import { useBreakpoint as u, Breakpoints as n, useNextgenRouter as S } from "@nextgen-web-framework/all";
import { ConfigService as w } from "@nextgen-web-framework/core";
import B from "../SharebarDrawer/SharebarDrawer.js";
import { useShareUserConfig as g } from "../../utils/sharebar/sharebarHelpers.js";
import '../../assets/MePanelSharebar.css';const C = {
  "me-panel-sharebar-container": "_me-panel-sharebar-container_12o31_1",
  "sharebar-modal-side-wrapper": "_sharebar-modal-side-wrapper_12o31_4"
}, v = ({ children: i, userType: e }) => {
  var s;
  const c = u(), l = [n.SM, n.XS].includes(c), [r, a] = _(!1), m = () => a(!1), o = () => a(!r), { shareTitle: p, shareDescription: d } = g(e), h = S(), f = `${w.getConfigs().NEXT_PUBLIC_WEB_BASE_PATH}/${(s = h.params) == null ? void 0 : s.locale}/signup?flowName=shareBarFlow&returnUri=/cart`;
  return /* @__PURE__ */ b("div", { className: C["me-panel-sharebar-container"], "data-testid": "me-panel-sharebar-test-id", "data-pod-name": "commerce", children: [
    /* @__PURE__ */ t(
      "div",
      {
        role: "presentation",
        onKeyDown: o,
        onClick: o,
        "data-testid": "sharebar-button-test-id",
        "data-pod-name": "commerce",
        children: i
      }
    ),
    r && /* @__PURE__ */ t(
      B,
      {
        backBtn: !l,
        accountType: e,
        shareTitle: p,
        shareDesc: d,
        fullUrl: f,
        onClose: m
      }
    )
  ] });
};
export {
  v as default
};
//# sourceMappingURL=MePanelSharebar.js.map
